module.exports = __webpack_public_path__ + "static/media/boot.b2b09d77.gif";